// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header */
.modal-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

/* Modal Body */
.modal-body {
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
}

/* Member Detail Container */
.member-detail-container {
  padding: 20px;
}

.member-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}

/* Info Card */
.info-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  background: #e9ecef;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-icon {
  font-size: 1.2rem;
}

.card-title {
  margin: 0;
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
}

.card-content {
  padding: 20px;
}

/* Info Item */
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #495057;
  min-width: 150px;
  margin-right: 15px;
}

.info-value {
  color: #6c757d;
  text-align: right;
  flex: 1 1;
  word-break: break-word;
}

.member-id {
  font-family: 'Courier New', monospace;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9rem;
}

/* Value Links */
.value-link {
  color: #0D3B66;
  text-decoration: none;
  word-break: break-all;
}

.value-link:hover {
  text-decoration: underline;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active,
.status-badge.approved,
.status-badge.current,
.status-badge.synced {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.inactive,
.status-badge.not_synced {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.suspended,
.status-badge.rejected,
.status-badge.failed,
.status-badge.overdue {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.pending,
.status-badge.needs_info {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.unknown {
  background-color: #e2e3e5;
  color: #383d41;
}

/* Modal Footer - Now using global styles from design-system.css */

/* Button Styles */
/* Buttons - Now using global styles from design-system.css */

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-width: 100%;
    max-height: 95vh;
  }

  .modal-header {
    padding: 15px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .member-detail-container {
    padding: 15px;
  }

  .member-info-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .card-header {
    padding: 12px 15px;
  }

  .card-content {
    padding: 15px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .info-label {
    min-width: auto;
    margin-right: 0;
  }

  .info-value {
    text-align: left;
  }

  .modal-footer {
    padding: 15px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px;
  }

  .modal-header h2 {
    font-size: 1.2rem;
  }

  .member-detail-container {
    padding: 12px;
  }

  .card-header {
    padding: 10px 12px;
  }

  .card-content {
    padding: 12px;
  }

  .info-item {
    padding: 6px 0;
  }

  .modal-footer {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/members/MemberDetailPopup.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE,qEAAqE;;AAErE,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kEAAkE;;AAElE,kBAAkB;AAClB,6DAA6D;;AAE7D;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header */\n.modal-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n/* Modal Body */\n.modal-body {\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Member Detail Container */\n.member-detail-container {\n  padding: 20px;\n}\n\n.member-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n/* Info Card */\n.info-card {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.card-header {\n  background: #e9ecef;\n  padding: 15px 20px;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.card-icon {\n  font-size: 1.2rem;\n}\n\n.card-title {\n  margin: 0;\n  color: #495057;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.card-content {\n  padding: 20px;\n}\n\n/* Info Item */\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 8px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #495057;\n  min-width: 150px;\n  margin-right: 15px;\n}\n\n.info-value {\n  color: #6c757d;\n  text-align: right;\n  flex: 1;\n  word-break: break-word;\n}\n\n.member-id {\n  font-family: 'Courier New', monospace;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n/* Value Links */\n.value-link {\n  color: #0D3B66;\n  text-decoration: none;\n  word-break: break-all;\n}\n\n.value-link:hover {\n  text-decoration: underline;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.active,\n.status-badge.approved,\n.status-badge.current,\n.status-badge.synced {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.inactive,\n.status-badge.not_synced {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-badge.suspended,\n.status-badge.rejected,\n.status-badge.failed,\n.status-badge.overdue {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-badge.pending,\n.status-badge.needs_info {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.unknown {\n  background-color: #e2e3e5;\n  color: #383d41;\n}\n\n/* Modal Footer - Now using global styles from design-system.css */\n\n/* Button Styles */\n/* Buttons - Now using global styles from design-system.css */\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #5a6268;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-width: 100%;\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 15px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .member-detail-container {\n    padding: 15px;\n  }\n\n  .member-info-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .card-header {\n    padding: 12px 15px;\n  }\n\n  .card-content {\n    padding: 15px;\n  }\n\n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n\n  .info-label {\n    min-width: auto;\n    margin-right: 0;\n  }\n\n  .info-value {\n    text-align: left;\n  }\n\n  .modal-footer {\n    padding: 15px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.2rem;\n  }\n\n  .member-detail-container {\n    padding: 12px;\n  }\n\n  .card-header {\n    padding: 10px 12px;\n  }\n\n  .card-content {\n    padding: 12px;\n  }\n\n  .info-item {\n    padding: 6px 0;\n  }\n\n  .modal-footer {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
